import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { auditTime, map, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';
import { Observable, Subject, forkJoin } from 'rxjs';
import { FORM_CONFIG as formConfig } from '../labels-f1';
import { ProductosInformacionService } from '../../../core/providers/services/productos-informacion/productos-informacion.service';
import { PaisesListarService } from '../../../core/providers/services/paises-listar/paises-listar.service';

import { ProductIdCorreduria, ProductosInformacionResInterface } from './../../../core/interfaces/producto-informacion.interface';
import { FormPropModel } from './../../../core/models/form-prop.model';
import { CountryListModel } from '../../../core/models/country-list.model';
import { SelectMultipleModel } from '../../../core/models/select-multiple.model';
import { UtilsService } from '@shared/services/utils/utils.service';
import { Numbers } from 'src/app/utils/constants';
import { PrefijoPaisesService } from 'src/app/core/providers/services/prefijo-paises/prefijo-paises.service';



@Component({
  selector: 'app-form1-travel-leisure',
  templateUrl: './form1-travel-leisure.component.html',
  styleUrls: ['./form1-travel-leisure.component.scss']
})
export class Form1TravelLeisureComponent implements OnInit, OnDestroy {

  /**
   * @description Es el formulario
   */
  @Input() productIdCorreduria: any[];
  @Input() FORM_DATA: FormGroup;

  /**
   * @description Es el formulario
   */
  formConfig: any;
  currentStep: number = Numbers.number1;
  modifyStepV = '';


  /**
   * @description Subject para finalizar suscripciones
   */
  private finish = new Subject();

  /**
   * @description Es un modelo de datos para el componente de botón
   */
  public dataButton = new FormPropModel({ classes: 'green', label: 'Siguiente' });

  public insuredChoosed: 'Particular' | 'Empresa' = 'Particular';
  /**
   * @description constructor
   * @params productServ
   * @params plSrv
   */
  constructor(
    private productServ: ProductosInformacionService,
    private plSrv: PaisesListarService,
    private utSrv: UtilsService,
    private prefixSrv: PrefijoPaisesService
  ) {
    this.productServ = productServ;
    this.plSrv = plSrv;
    this.utSrv = utSrv;
    this.prefixSrv = prefixSrv;
  }

  newFormConfig: any = {
    ...formConfig
  };
  /**
   * @description Metodo de inicio
   */
  ngOnInit(): void {

        this.newFormConfig.currentStep.pipe(
          take(1)
        ).subscribe(step => {
          this.currentStep = step;
        });
        this.getCurrentStep();
        this.subs();
        this.newFormConfig.guaranteeLimitOfMedicalExpenses.options.list = [];
        const listAseg: any[] = [];
        for (let index = 1; index <= Numbers.number100; index++) {
          listAseg.push({ name: `${index}`, id: index });
        }
        this.newFormConfig.numberOfInsured.options.list = listAseg;
        this.newFormConfig.numberOfInsuredList = listAseg;
        if (!(this.productIdCorreduria.length === 1 && this.productIdCorreduria[0] === 0)) {
          this.productIdCorreduria.map(elId => {
            this.listData(elId.producto);

          });
        } else {
          // this.productServ.getProductInfo(Numbers.number17118).pipe(
          //   take(1),
          //   switchMap((el: ProductosInformacionResInterface) => {
          //     el.name = (Numbers.number12000).toString();
          //     this.newFormConfig.guaranteeLimitOfMedicalExpenses.options.list.push(el);
          //     return this.getPrefix();
          //   })
          // ).subscribe();
        }
        this.productServ.getProductInfo(Numbers.number17118).pipe(
          take(1),
          switchMap((el: ProductosInformacionResInterface) => {
            el.name = (Numbers.number12000).toString();
            this.newFormConfig.guaranteeLimitOfMedicalExpenses.options.list.push(el);
            return this.getPrefix();
          })
        ).subscribe();
  }

  /**
   * @description listData
   * @param index2 indice del for
   */
  public listData(index2: any): void {
    this.productServ.getProductInfo(index2)
    .pipe(take(1))
    .subscribe((el: ProductosInformacionResInterface) => {
      const idP: number = this.utSrv.stringToNumber(el.nombreProducto);
      el.name = (idP === 0) ? (Numbers.number12000).toString() : idP.toString();
      this.newFormConfig.guaranteeLimitOfMedicalExpenses.options.list.push(el);
      this.newFormConfig.guaranteeLimitOfMedicalExpenses.options.list =
        this.newFormConfig.guaranteeLimitOfMedicalExpenses.options.list.sort((a, b) => a.name - b.name);
    });
  }

  /**
   * @description Metodo de fin
   */
  ngOnDestroy() {
    this.finish.next(true);
  }

  /**
   * @description Cambia el valor del formulario
   */
  private subs(): void {
    if (!this.FORM_DATA) { return; }
    this.FORM_DATA.valueChanges.pipe(
      takeUntil(this.finish),
      tap(el => {
      })
    ).subscribe();
  }

  /**
   * @description Consigue el valor de una propiedad del formulario
   */
  public getCurrentStep(): void {
    this.newFormConfig.currentStep.pipe(
      takeUntil(this.finish)
    ).subscribe(step => {
      this.currentStep = step;
    });
  }

  /**
   * @description Cambio de paso, siguiente o anterior
   */
  public modifyStep(ev: 'back' | 'next'): void {
    if (ev === 'next') {
      this.formConfig.stepIncrement();
    }
    if (ev === 'back') {
      this.formConfig.stepDecrement();
    }

    this.modifyStepV = ev;
  }

  /**
   * @description Cambio de tomador particular o empresa
   */
  changeInsuredType(ev: 'Particular' | 'Empresa'): void {
    this.insuredChoosed = ev;
  }

  /**
   * @description Retorna el tipo de tomador particular o empresa
   */
  getInsuredTypeChoosed(): 'Particular' | 'Empresa' {
    return this.insuredChoosed;
  }

  /**
   * Obtenemos el listado de prefijos telefónicos
   * @returns el listado de prefijos telefónicos
   */
  getPrefix(): Observable<any> {
    return this.prefixSrv.getPrefix().pipe(
      take(1),
      switchMap((prefijo) => {
        this.newFormConfig.insuredData.prefix.options.list = prefijo;
        this.newFormConfig.emergencyContact.prefix.options.list = prefijo;

        return this.plSrv.getCountryList().pipe(
          take(1),
          switchMap((paisesList: any[]) => {
            // Pais Destino - Multiple
            const countryList: CountryListModel[] = paisesList.map(s => new CountryListModel(s));
            const multipleCountryList: SelectMultipleModel[] = countryList.map(u => new SelectMultipleModel(u));
            // El primer pais es "Seleccionar" por eso lo eliminamos.
            // multipleCountryList.shift();
            // Pais Origen - Simple
            const simpleCountryList: any[] = multipleCountryList.map(r => r.value);
            this.newFormConfig.insuredData.country.options.list = simpleCountryList.sort((a, b) => a.name - b.name);
            this.formConfig = this.newFormConfig;
            return [];
          })
        );
      })
    );
  }
}
